import { render, staticRenderFns } from "./CashShopBrowser.vue?vue&type=template&id=0c3f007a&scoped=true&"
import script from "./CashShopBrowser.vue?vue&type=script&lang=ts&"
export * from "./CashShopBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./CashShopBrowser.vue?vue&type=style&index=0&id=0c3f007a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f007a",
  null
  
)

export default component.exports